import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const Row = styled(Box)({
  marginBottom: "1rem",
});

export default Row;
